if($(".js-produkt_liste_search").length != 0){
    htmlRoot = $(".js-produkt_liste_search").data("root");
    var listItemAjax = htmlRoot + 'cmshx_template/ajax/ecprod_get_search.php';
    var listLimitAjax =  htmlRoot + 'cmshx_template/ajax/set_list_limiter.php';

    $produktList = newWkoList();
    $produktList.setListLimit(parseInt($(".js-produkt_liste_search").data("limit")));
    $produktList.setListLimitAjax(listLimitAjax);
    $produktList.setListItemIds(listItemIds);
    $produktList.setListItemAjax(listItemAjax);
    $produktList.setCurrentPage(parseInt($(".js-produkt_liste_search").data("page")));
    $produktList.addToAjax(parseInt($(".js-produkt_liste_search").data("menu")));
    $produktList.addToUrlHistory("s", addToUrlHistory);
    $produktList.setPagerElement($(".js-list_pager_pages"));
    $produktList.setPagerPagesElement($("<a class='produkt_list_pager_pages_item'></a>"));
    $produktList.setPageLimiter($(".js-list_limiter"));
    $produktList.setAmountWithPageElement($(".js-list_amount_with_page"));
    $produktList.setAmountWithOutPageElement($(".js-list_amount_without_page"));
    if($(".js-list_ges").length > 0) $produktList.setGesCon($(".js-list_ges"));
    if($(".js-list_from").length > 0) $produktList.setFromCon($(".js-list_from"));
    if($(".js-list_to").length > 0) $produktList.setToCon($(".js-list_to"));
    $produktList.init($(".js-produkt_liste_search"));
}
